<template>
<div class="chapter">
<div class="inner_page">
<h1 class="larger">Once Later</h1>
<blockquote class="indent3">
<p class="left spaceabove1"><em>It is not until later</em></p>
<p class="left "><em>that you have to be young</em></p>
<p class="left spaceabove1"><em>it is one of the things</em></p>
<p class="left "><em>you meant to do later</em></p>
<p class="left spaceabove1"><em>but by then there is</em></p>
<p class="left "><em>someone else living there</em></p>
<p class="left spaceabove1"><em>with the shades rolled down</em></p>
<p class="left "><em>how could you have been young there</em></p>
<p class="left spaceabove1"><em>at that time</em></p>
<p class="left "><em>with all that was expected</em></p>
<p class="left spaceabove1"><em>then what happened to</em></p>
<p class="left "><em>the expectations</em></p>
<p class="left spaceabove1"><em>there is no sign of them there</em></p>
<p class="left "><em>a shadow passes across the window</em></p>
<p class="left "><em>shade</em></p>
<p class="left spaceabove1"><em>what do they know in there</em></p>
<p class="left "><em>whoever they are</em></p>
<p class="right "><span class="smallcaps">—W. S. MERWIN</span></p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front03.vue?b37fa7c4